/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum UtilizationMachineStateType {
    OFFLINE = 'OFFLINE',
    IDLE = 'IDLE',
    RUNNING = 'RUNNING',
    CRINKLE_CARE = 'CRINKLE_CARE',
    PROGRAM_PAUSED = 'PROGRAM_PAUSED',
    FATAL_ERROR = 'FATAL_ERROR'
}


export function UtilizationMachineStateTypeFromJSON(json: any): UtilizationMachineStateType {
    return UtilizationMachineStateTypeFromJSONTyped(json, false);
}

export function UtilizationMachineStateTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UtilizationMachineStateType {
    return json as UtilizationMachineStateType;
}

export function UtilizationMachineStateTypeToJSON(value?: UtilizationMachineStateType | null): any {
    return value as any;
}

